import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Button } from '@material-ui/core';
import ConfirmTextButton from '../atoms/ConfirmTextButton';

const styles = {
  wordBreak: {
    wordBreak: 'break-all',
    whiteSpace: 'break-spaces'
  },
  ngReasonCol: {
    minWidth: '400px',
    width: '500px'
  },
  addressCol: {
    minWidth: '100px',
    width: '200px',
    whiteSpace: 'break-spaces'
  },
  shopNameCol: {
    minWidth: '100px',
    width: '200px',
    whiteSpace: 'break-spaces'
  },
  groupNameCol: {
    minWidth: '100px',
    width: '200px',
    whiteSpace: 'break-spaces'
  }
};

const enhance = compose(pure);

const IdentityUserKidTableBody = enhance(
  ({
    classes,
    identityUserKid,
    emptyRows,
    openDetailUserKid,
    page,
    rowsPerPage,
    confirmOpenAction,
    roles,
    orderBy,
    order,
    poorStatusArr
  }) => {
    const sortedResult = _.orderBy(identityUserKid, orderBy, order);

    const getPoorStatus = status => {
      let element = '';
      poorStatusArr.forEach(item => {
        if (item.label === status) {
          element = item.name;
        }
      });
      return element;
    };

    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(result => {
            const key = `${result.userId}`;
            return (
              <TableRow key={key}>
                <TableCell>{result.userId}</TableCell>
                <TableCell>
                  <Button
                    className={classes.textBody}
                    variant="text"
                    color="Primary"
                    onClick={() => openDetailUserKid(result.userId)}
                  >
                    {result.displayName}
                  </Button>
                </TableCell>
                <TableCell>{result.email}</TableCell>
                <TableCell>
                  {result.poorStatus && result.poorStatus !== 'INIT'
                    ? 'する'
                    : 'しない'}
                </TableCell>
                <TableCell>{result.confirmAt}</TableCell>
                <TableCell>{result.lastCreatedAt}</TableCell>
                <TableCell>
                  {result.poorStatus ? getPoorStatus(result.poorStatus) : ''}
                </TableCell>
                <TableCell>
                  {`審査OK - ${result.sumChildrenOk}`}
                  <br />
                  {`審査NG - ${result.sumChildrenNg}`}
                  <br />
                  {`審査中 - ${result.sumChildrenReview}`}
                  <br />
                  {`再提出依頼中 - ${result.sumChildrenResubmit}`}
                </TableCell>
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>
                    <ConfirmTextButton
                      params={result}
                      onClickAction={() => confirmOpenAction(result.userId)}
                      enabled={
                        !(
                          (result.poorStatus === 'OK' ||
                            result.poorStatus === 'INIT') &&
                          result.allChildren &&
                          result.sumChildrenOk &&
                          result.allChildren === result.sumChildrenOk
                        )
                      }
                    />
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(IdentityUserKidTableBody);
